<template>
  <el-card class="card linkFormTagCard" data-section-id="tag">
    <div slot="header" class="linkFormTagCard__header">
      <strong class="linkFormTagCard__title">
        关联 Tag
        <span v-if="tagsRequired" class="linkFormTagCard__req">*</span>
      </strong>
      <span
        v-if="showCompletionStatus"
        class="linkFormTagCard__status"
        :class="completionDone ? 'linkFormTagCard__status--done' : 'linkFormTagCard__status--pending'"
      >
        {{ completionDone ? '✓ 已完成' : '未完成' }}
      </span>
    </div>
    <div class="linkFormTagCard__body">
      <div class="linkFormTagCard__row">
        <div class="linkFormTagCard__tags">
          <el-tag
            v-for="tag in displayTags"
            :key="tag.key"
            closable
            :disable-transitions="false"
            class="linkFormTagCard__pill"
            @close="removeTag(tag.key)"
          >
            {{ tag.name }}
          </el-tag>
          <span v-if="!displayTags.length" class="linkFormTagCard__empty">
            {{ emptyHint }}
          </span>
        </div>
        <button
          type="button"
          class="linkFormTagCard__addBtn"
          @click="openPicker"
        >
          <i class="el-icon-plus" aria-hidden="true" />
          添加 Tag
        </button>
      </div>
    </div>

    <association-picker-dialog
      title="关联 Tag"
      :visible.sync="pickerOpen"
      @confirm="applyPicker"
      @cancel="discardPicker"
      @closed="discardPicker"
    >
      <tag-picker v-model="draftTags" />
    </association-picker-dialog>
  </el-card>
</template>

<script>
import AssociationPickerDialog from './AssociationPickerDialog.vue'
import TagPicker from '../batchTag/tagPicker.vue'

/**
 * 通用资源创建/编辑 · 关联 Tag 区块。
 * 布局与关联分类对称：chip / 空态 + 右侧添加入口。
 * workout_action 下由 tagsRequired 驱动必填角标与空态文案。
 */
export default {
  name: 'LinkFormTagCard',
  components: {
    AssociationPickerDialog,
    TagPicker,
  },
  props: {
    tagVOList: {
      type: Array,
      default: () => [],
    },
    /** 动作资源：至少 1 个 Tag（部位等） */
    tagsRequired: {
      type: Boolean,
      default: false,
    },
    showCompletionStatus: {
      type: Boolean,
      default: false,
    },
    completionDone: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      pickerOpen: false,
      draftTags: [],
    }
  },
  computed: {
    displayTags() {
      return Array.isArray(this.tagVOList) ? this.tagVOList : []
    },
    emptyHint() {
      if (this.tagsRequired) {
        return '至少关联一个 Tag（如胸、背、瑜伽等部位）'
      }
      return '暂未关联 Tag'
    },
  },
  methods: {
    openPicker() {
      this.draftTags = this.displayTags.map((tag) => ({
        key: tag.key,
        name: tag.name,
      }))
      this.pickerOpen = true
    },
    applyPicker() {
      this.$emit('update:tagVOList', [...this.draftTags])
    },
    discardPicker() {
      this.draftTags = this.displayTags.map((tag) => ({
        key: tag.key,
        name: tag.name,
      }))
    },
    removeTag(tagKey) {
      const next = this.displayTags.filter((tag) => tag.key !== tagKey)
      this.$emit('update:tagVOList', next)
    },
  },
}
</script>

<style scoped>
.linkFormTagCard__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.linkFormTagCard__title {
  font-size: 14px;
}

.linkFormTagCard__req {
  color: #f56c6c;
  margin-left: 2px;
}

.linkFormTagCard__status {
  font-size: 12px;
  font-weight: 500;
  flex-shrink: 0;
}

.linkFormTagCard__status--pending {
  color: #e6a23c;
}

.linkFormTagCard__status--done {
  color: #67c23a;
}

.linkFormTagCard__row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.linkFormTagCard__tags {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  flex: 1;
  min-width: 0;
}

.linkFormTagCard__pill {
  margin: 0;
}

.linkFormTagCard__empty {
  font-size: 12px;
  color: var(--link-ink-muted, #78716c);
  line-height: 28px;
}

.linkFormTagCard__addBtn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
  min-height: 28px;
  padding: 0 12px;
  border: 1px dashed var(--link-accent-border, #cce5ff);
  border-radius: 999px;
  background: var(--link-accent-bg, #f0f7ff);
  font-size: 12px;
  font-weight: 500;
  color: var(--link-accent, #2563eb);
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;
}

.linkFormTagCard__addBtn:hover {
  border-color: var(--link-accent, #2563eb);
  background: var(--link-accent-soft, rgba(37, 99, 235, 0.07));
  color: var(--link-accent-hover, #1d4ed8);
}
</style>
